import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers } from 'recompose'
import { push } from 'react-router-redux'
import config from 'config'
import { track } from 'utils/trackingUtils'
import { popUp, encodeQueryData } from '../../utils/oauthUtils'
import { CONNECT_ERRORS } from '../component'
import MicrosoftOauth from './component'

const MICROSOFT_OAUTH_BASE_URL = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize'


const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    push,
  }, dispatch),
})

const params = {
  response_type: 'code',
  response_mode: 'query',
  redirect_uri: `${config.CUSTOMER_WEB_URL}/accept-integration/office-365-calendar`,
  client_id: config.MICROSOFT_CALENDAR_CLIENT_ID,
  scope: 'openid profile offline_access User.Read Calendars.ReadWrite',
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onConnectClick: props => () => {
      popUp({
        path: `${MICROSOFT_OAUTH_BASE_URL}?${encodeQueryData(params)}`,
        onMessage: (e) => {
          const success = e.data.status === 'success'
          if (success) {
            track('Onboarding Meetings Calendar Method Chosen', {
              context: 'sales-onboarding',
              method: 'office-365,'
            })
            track('Calendar Connected', { context: 'onboarding' })
            window.drift && window.drift.api && window.drift.api.setUserAttributes({ first_calendar_connect: true })
            if (props.isCalendarSeat) {
              props.actions.push('/setup/calendaring/select')
            } else {
              props.actions.push('/setup/meetings/calendar')
            }
          } else {
            props.setConnectError(CONNECT_ERRORS.MICROSOFT)
          }
        },
      })
    },
  }),
)(MicrosoftOauth)



// WEBPACK FOOTER //
// ./src/layouts/MeetingsStepWithPrime/MicrosoftOauth/index.js